const { fetchWithRetry } = require('./utils'); // Utility function to parse cookies  

// Function to create a new event  
const createEvent = async (eventData) => {
    try {
        const response = await fetchWithRetry('/api/events', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(eventData),
        });

        if (!response.ok) {
            throw new Error(`Error creating event: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating event:', error);
        throw error;
    }
};

// Function to get all events  
const getAllEvents = async () => {
    try {
        const response = await fetchWithRetry('/api/events/all', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching events: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching events:', error);
        throw error;
    }
};

// Function to get solo events  
const getSoloEvents = async () => {
    try {
        const response = await fetchWithRetry('/api/events/solo', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching solo events: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching solo events:', error);
        throw error;
    }
};

// Function to get group events  
const getGroupEvents = async () => {
    try {
        const response = await fetchWithRetry('/api/events/group', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching group events: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching group events:', error);
        throw error;
    }
};

// Function to delete an event  
const deleteEvent = async (eventId) => {
    try {
        const response = await fetchWithRetry('/api/events', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: eventId }),
        });

        if (!response.ok) {
            throw new Error(`Error deleting event: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting event:', error);
        throw error;
    }
};

// Function to get contestant events  
const getContestantEvents = async () => {
    try {
        const response = await fetchWithRetry('/api/events/contestant', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching contestant events: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching contestant events:', error);
        throw error;
    }
};

// Function to update an event  
const updateEvent = async (eventId, updateData) => {
    try {
        const response = await fetchWithRetry(`/api/events/${eventId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updateData),
        });

        if (!response.ok) {
            throw new Error(`Error updating event: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating event:', error);
        throw error;
    }
};

module.exports = {
    createEvent,
    getAllEvents,
    getSoloEvents,
    getGroupEvents,
    deleteEvent,
    getContestantEvents,
    updateEvent,
};  